<nsc-card>
  <nsc-card-title>Fee Summary</nsc-card-title>
  <nsc-card-content>
    <div class="row">
      <div class="col-12 col-lg-6">

        <table class="fee-summary-table" role="table" aria-label="Fee Summary">
          <tbody>
            @if (fees.transcriptFee !== 0) {
              <tr>
                <th scope="row" class="fee-summary-table__label">Transcript Quantity Fee</th>
                <td class="fee-summary-table__value">{{ fees.transcriptFee | currency }}</td>
              </tr>
            }

            @if (fees.deliveryFee !== 0) {
              <tr>
                <th scope="row" class="fee-summary-table__label">{{ fees.deliveryFeeDescription }}</th>
                <td class="fee-summary-table__value">{{ externalVendorFeeApplicable && printVendorDeliveryFeePaidBy!=='S' ? 'TBD' : (fees.deliveryFee | currency) }}</td>
              </tr>
            }

            @if (fees.transcriptTypeFee !== 0) {
              <tr>
                <th scope="row" class="fee-summary-table__label">Transcript Type Fee</th>
                <td class="fee-summary-table__value">{{ fees.transcriptTypeFee | currency }}</td>
              </tr>
            }

            @if (fees.shippingAndHandlingFee !== 0) {
              <tr>
                <th scope="row" class="fee-summary-table__label">Shipping and Handling Fee</th>
                <td class="fee-summary-table__value">{{ fees.shippingAndHandlingFee | currency }}</td>
              </tr>
            }

            @if (fees.onlineProcessingFee !== 0) {
              <tr>
                <th scope="row" class="fee-summary-table__label">Online Processing Fee</th>
                <td class="fee-summary-table__value">{{ fees.onlineProcessingFee | currency }}</td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr class="fee-summary-table__total-row">
              <th scope="row" class="fee-summary-table__label fee-summary-table__label--total">{{ totalFeeLabel }}</th>
              <td class="fee-summary-table__value fee-summary-table__value--total">
                <strong>{{ externalVendorFeeApplicable && printVendorDeliveryFeePaidBy!=='S' ? '' : (fees.totalFee | currency) }}</strong>
                @if ((isSPDESchool || isFASTSchool || (isTNSchool && fees.totalFee === 0))) {
                  <button (click)="viewTotalFeeTNDetails()" mat-icon-button aria-label="info">
                    <mat-icon>info</mat-icon>
                  </button>
                }
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </nsc-card-content>
</nsc-card>